export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8327.b759c6ce.jpg";